export default __webpack_public_path__ + "static/media/play_icon_bold.75f8e70f.svg";